export default __webpack_public_path__ + "static/media/bb-00001.5d8af16b.png";